<template>
  {{ messages.length ? messages[0] : '' }}
</template>

<script setup lang="ts">
import { computed, watch } from '@/composition/vue/compositionApi'
import { getErrorMessagesComputed } from '@/composition/forms/formMessages'
import type { ValidationRuleError, ValidationServerError } from '@/services/validation/types'

const props = withDefaults(
  defineProps<{
    field: string
    errorCustomMessage?: string
    invalid: boolean
    errors?: ValidationRuleError[]
    serverErrors?: ValidationServerError[]
  }>(),
  {
    errors: () => [],
    serverErrors: () => [],
  },
)

const emit = defineEmits<{
  'show-error': []
}>()

const messages = getErrorMessagesComputed(props)

const quantityMessages = computed(() => messages.value.length)

watch(
  quantityMessages,
  (value) => {
    if (value === 0) {
      return
    }
    emit('show-error')
  },
  {
    immediate: true,
  },
)
</script>
